export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
export const toStorageUrl = (pathname: string) => process.env.REACT_APP_API_STORAGE_URL + pathname
export const PATH_AVATAR_BLANK = '/media/avatars/blank.png'
